import alishaSrc from "@/assets/home-new/avatars/alisha.avif"
import andreaSrc from "@/assets/home-new/avatars/andrea.avif"
import danielSrc from "@/assets/home-new/avatars/daniel.avif"
import georgSrc from "@/assets/home-new/avatars/georg.avif"
import kaiSrc from "@/assets/home-new/avatars/kai.avif"
import ninaSrc from "@/assets/home-new/avatars/nina.avif"
import patSrc from "@/assets/home-new/avatars/pat.avif"
import peterSrc from "@/assets/home-new/avatars/peter.avif"
import peytonSrc from "@/assets/home-new/avatars/peyton.avif"
import robinSrc from "@/assets/home-new/avatars/robin.avif"
import stefanSrc from "@/assets/home-new/avatars/stefan.avif"
import svenSrc from "@/assets/home-new/avatars/sven.avif"

// Team photos for the homepage's 24px avatars: 72px AVIF crops (3x) of the
// 500×600 PNGs in public/images/team, which are ~290 KB each. The company
// page keeps using the full-size originals.
export const teamAvatars = {
  alisha: alishaSrc,
  andrea: andreaSrc,
  daniel: danielSrc,
  georg: georgSrc,
  kai: kaiSrc,
  nina: ninaSrc,
  pat: patSrc,
  peter: peterSrc,
  peyton: peytonSrc,
  robin: robinSrc,
  stefan: stefanSrc,
  sven: svenSrc,
} as const
